import { render, staticRenderFns } from "./addContactOrg.vue?vue&type=template&id=724501b2&lang=pug"
import script from "./addContactOrg.vue?vue&type=script&lang=js"
export * from "./addContactOrg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports